import { render, staticRenderFns } from "./NotificationPopups.vue?vue&type=template&id=b4b1b9cc&scoped=true&"
import script from "./NotificationPopups.vue?vue&type=script&lang=js&"
export * from "./NotificationPopups.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopups.vue?vue&type=style&index=0&id=b4b1b9cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b1b9cc",
  null
  
)

export default component.exports